module.exports = __webpack_public_path__ + "img/logo.34d49bf8.svg";